<template>
  <div class="hinnakiri-page">
    <HeaderComp />
    <div class="hinnakiri-container">
      <div class="hinnakiri">
        <h1>Hinnakiri</h1>
        <table class="price-table">
          <thead>
            <tr>
              <th></th>
              <th>Plekkvelg</th>
              <th>Valuvelg >16"</th>
              <th>Valuvelg 17"-19"</th>
              <th>Valuvelg 20"<</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ item.name }}</td>
              <td data-label="Plekkvelg">{{ item.plekk }}</td>
              <td data-label='Valuvelg >16"'>{{ item.valu16 }}</td>
              <td data-label='Valuvelg 17"-19"'>{{ item.valu17 }}</td>
              <td data-label='Valuvelg 20"<'>{{ item.valu20 }}</td>
            </tr>
          </tbody>
        </table>
        <h2>Veoauto</h2>
        <table class="price-table">
          <thead>
            <tr>
              <th></th>
              <th>Hind</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemsveoauto" :key="index">
              <td>{{ item.name }}</td>
              <td data-label="Hind">{{ item.price }}</td>
            </tr>
          </tbody>
        </table>
        <h2>Lisateenused</h2>
        <table class="price-table">
          <thead>
            <tr>
              <th></th>
              <th>Hind</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemslisa" :key="index">
              <td>{{ item.name }}</td>
              <td data-label="Hind">{{ item.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "Hinnakiri",
  components: {
    HeaderComp,
    FooterComp,
  },
  data() {
    return {
      itemsveoauto: [
        {
          name: "Montaaz",
          price: "13€",
        },
        {
          name: "Tasakaalustamine",
          price: "16€",
        },
        {
          name: "Rattavahetus",
          price: "13€",
        },
        {
          name: "Paarisrattavahetus",
          price: "16€",
        },
        {
          name: "Traktori ning muu rasketehnika rehvivahetus ja remont",
          price: "Hind kokkuleppel",
        },
      ],
      itemslisa: [
        {
          name: "Rehviremont (sis montaaz + paik)",
          price: "AL 25€",
        },
        {
          name: "Veljeäärte puhastus (sis hermeetik)",
          price: "AL 15€",
        },
        {
          name: "Kilpide kinnitamine",
          price: "2€",
        },
        {
          name: "Õhukummi paik",
          price: "AL 3€",
        },
        {
          name: "Utiil transport",
          price: "2€ Tk",
        },
        {
          name: "Valuvelgede sirgendamine",
          price: "AL 30€",
        },
        {
          name: "4 rehvi hoiustamine (hooaeg)",
          price: "20€",
        },
        {
          name: "4 ratta hoiustamine (hooaeg)",
          price: "25€",
        },
        {
          name: "Lukksepa tund",
          price: "45€",
        },
        {
          name: "Sildade reguleerimine",
          price: "AL 55€",
        },
      ],
      items: [
        {
          name: "Sõiduauto",
          plekk: "45€",
          valu16: "50€",
          valu17: "60€",
          valu20: "75€",
        },
        {
          name: "Kaubik",
          plekk: "55€",
          valu16: "60€",
          valu17: "65€",
          valu20: "80€",
        },
        {
          name: "Maastur",
          plekk: "60€",
          valu16: "60€",
          valu17: "70€",
          valu20: "80€",
        },

        {
          name: "Tasakaalustamine + Rattamontaaz",

          plekk: "30€",
          valu16: "35€",
          valu17: "40€",
          valu20: "45€",
        },
        {
          name: "Rattavahetus",
          plekk: "3-5€",
        },
        {
          name: "Rehvimontaaz",
          plekk: "5€",
          valu16: "5€",
          valu17: "6€",
          valu20: "8€",
        },
        {
          name: "Tasakaalustamine",
          plekk: "5€",
          valu16: "6€",
          valu17: "7€",
          valu20: "8€",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Alata&display=swap");

* {
  font-family: "Alata", sans-serif;
}

.hinnakiri-page {
  min-height: 100vh;
  background: #151217;
}

.hinnakiri-container {
  min-height: 80vh;
  padding: 44px 20px 66px 20px;
  background:
    linear-gradient(180deg, #151217 0, #151217 96px, #fff7fb 96px, #ffffff 100%);
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .hinnakiri-container {
    padding: 20px 10px 40px 10px;
    overflow-x: hidden;
    background:
      linear-gradient(180deg, #151217 0, #151217 54px, #fff7fb 54px, #ffffff 100%);
  }

  .hinnakiri {
    width: 100%;
    margin-top: 0;
  }
}

@media (max-width: 560px) {
  .hinnakiri {
    max-width: 370px;
    margin-left: 0;
    margin-right: auto;
  }
}

.hinnakiri {
  padding: 34px;
  background-color: #ffffff;
  border: 1px solid #f0bdd3;
  border-radius: 8px;
  box-shadow: 0 28px 70px rgba(42, 22, 34, 0.14);
  width: min(100%, 1080px);
  box-sizing: border-box;
  text-align: left;
  margin-top: 0;
  overflow-x: auto;
  margin-left: auto;
  margin-right: auto;
}

.price-table {
  width: 100%;
  min-width: 680px;
  margin: 18px 0 38px 0;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #ead4df;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.price-table:not(:first-of-type) {
  min-width: 420px;
}

.price-table th,
.price-table td {
  padding: 15px 16px;
  border-bottom: 1px solid #f2e4eb;
  word-wrap: break-word;
  white-space: normal;
}

.price-table thead th {
  background: #211820;
  color: #ffffff;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
  border-bottom: 4px solid #e22289;
}

.price-table tbody tr {
  background-color: #ffffff;
  transition: background-color 0.2s ease;
}

.price-table tbody tr:nth-child(even) {
  background-color: #fff8fc;
}

.price-table tbody tr:hover {
  background-color: #ffeaf4;
}

.price-table th:first-child,
.price-table td:first-child {
  text-align: left;
  font-weight: 700;
  color: #211820;
}

.price-table th:not(:first-child),
.price-table td:not(:first-child) {
  text-align: center;
}

.hinnakiri h1 {
  position: relative;
  margin: 0 0 28px 0;
  color: #211820;
  font-size: clamp(2.2rem, 6vw, 4.2rem);
  line-height: 0.95;
  font-weight: 800;
  padding-bottom: 16px;
}

.hinnakiri h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: min(220px, 64vw);
  height: 5px;
  background: #e22289;
}

.hinnakiri h2 {
  color: #211820;
  border-left: 5px solid #e22289;
  padding-left: 14px;
  text-align: left;
  margin: 34px 0 14px 0;
  font-size: 1.5em;
  font-weight: 800;
}

.hinnakiri p {
  background-color: #fff2f8;
  padding: 10px 16px;
  border-radius: 6px;
  border-left: 4px solid #e22289;
  margin: 10px 0;
  font-style: italic;
  color: #666;
}

@media (max-width: 768px) {
  .hinnakiri {
    padding: 22px 12px 28px 12px;
    overflow-x: visible;
  }

  .price-table {
    min-width: 0;
    display: block;
    border: 0;
    background: transparent;
    overflow: visible;
  }

  .price-table:not(:first-of-type) {
    min-width: 0;
  }

  .price-table thead {
    display: none;
  }

  .price-table tbody,
  .price-table tr,
  .price-table td {
    display: block;
    width: 100%;
  }

  .price-table tr {
    overflow: hidden;
    margin-bottom: 12px;
    border: 1px solid #ead4df;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 24px rgba(42, 22, 34, 0.08);
  }

  .price-table td {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    text-align: right;
  }

  .price-table td::before {
    content: attr(data-label);
    color: #5f4b58;
    font-weight: 700;
    text-align: left;
  }

  .price-table td:first-child {
    display: block;
    background: #211820;
    color: #ffffff;
    border-bottom: 4px solid #e22289;
    text-align: left;
  }

  .price-table td:first-child::before {
    content: none;
  }

  .price-table td:empty {
    display: none;
  }

  .price-table th,
  .price-table td {
    padding: 12px 12px;
    font-size: 0.95rem;
  }

  .hinnakiri h1 {
    font-size: clamp(2.15rem, 12vw, 3.2rem);
  }
}

@media (max-width: 560px) {
  .hinnakiri {
    width: calc(100% - 20px);
    max-width: 370px;
    margin-left: 0;
    margin-right: auto;
  }
}
</style>
